import React from "react";
import { MimaButton, MimaDropdown, MimaText, MimaTextArea, Modal } from "../../components";
import styles from "../../assets/styles/Admin/Admin.module.scss";
import { Formik, validateYupSchema } from "formik";




const RevokeAdmin = ({data, loading, onSubmit, closeModal, submitRevoke}) => {
    return (
        <Modal closeModal={closeModal}>
            <Formik
    initialValues={{
        status: data?.status || "",
        reason: "",
    }}
    onSubmit={onSubmit}
// validationSchema={validateYupSchema}
>
    {({ handleBlur,
        handleChange,
        setFieldValue,
        values,
        handleSubmit }) => (
        <>
            <MimaText width="38" align="center" mb="5" variant="subtitleBold" color="#4A4A68">{data?.firstname} {data?.lastname}</MimaText>
            <MimaText width="38" align="center" mb="3">Currently {data?.status}. Select status below to make {data?.status === "INACTIVE" ? "ACTIVE" : "INACTIVE"}</MimaText>
            <MimaDropdown
                labelTitle="Status"
                placeholder="Select Status"
                name="status"
                value={values.status}
                id="status"
                data={[
                    { value: "INACTIVE", key: "INACTIVE" },
                    { value: "ACTIVE", key: "ACTIVE" }
                ]}
                onChange={data => {
                    setFieldValue('status', data.key);
                }}
            />
            <MimaTextArea
                variant="message"
                placeholder="Input Reason"
                name="reason"
                value={values.reason}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <MimaButton
                title="Update"
                type="submit"
                onClick={() => {
                    handleSubmit(data._id)
                }}
                mt={2}
                width="38"
                buttonColor="#60607A"  
                loading={loading}              
            />            
        </>
    )}

</Formik>
        </Modal>
    )
}
export default RevokeAdmin;